import one from '../assets/png/odapi-screenshot.png'//'../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/cube.avif'
import three from '../assets/svg/projects/DA1.png'
import sodibat from '../assets/png/sodibat.png'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'SODIBAT Entreprise',
        projectDesc: ' Website made for Yessifou SADIKOU, expert in Ivorian real estate',
        code:'',
        tags: [],
        demo: 'https://sites.google.com/view/sadibat-entreprise/',
        image: sodibat
    },
    {
        id: 2,
        projectName: 'Investment planning tool',
        projectDesc: 'This project aims to build an tool that helps in planning an investment and calculate its RoI',
        tags: ['React', 'CSS', 'Material Ui'],
        code: 'https://github.com/hxckinson/Odapi/tree/master',
        demo: '',//'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: one
    },
    {
        id: 3,
        projectName: 'World of Shapes',
        projectDesc: 'Video game based on the same mechanics of Minecraft. It is a demo and the development stopped a very long time ago',
        tags: ['Blender', 'Python'],
        code: 'https://github.com/hxckinson/World-of-Shapes',
        demo: '',
        image: two
    },
    {
        id: 4,
        projectName: 'Desert Areas',
        projectDesc: 'Demo showcasing some landscape designed on Blender',
        tags: ['Blender', 'Python'],
        code: 'https://github.com/hxckinson/Desert-Areas/blob/master/README.md',
        demo: '',
        image: three
    }
    // {
    //     id: 3,
    //     projectName: 'Weather App',
    //     projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
    //     tags: ['Django', 'CSS', 'Material Ui'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: three
    // },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/